import { Center, Box, Heading, Text, VStack, Icon } from "@chakra-ui/react";
import { FaCheckCircle } from "react-icons/fa"; // Importe o ícone de 'check'

function SuccessScreen() {
  return (
    <Center w="100%" h="100vh" bg="#e5f8ee">
      <Box
        maxW="md"
        mx="auto"
        w="100%"
        p={6}
        borderWidth={1}
        borderRadius="lg"
        boxShadow="xl"
        bg="white"
        borderColor="#25D366"
        textAlign="center"
      >
        <VStack spacing={2}>
          <Icon as={FaCheckCircle} color="#25D366" boxSize="50px" />
          <Heading size="lg" color="#075E54">
            Sucesso!
          </Heading>
          <Text fontSize="md" color="#333">
            Recebemos seu contato. Em breve, um de nossos especialistas entrará
            em contato com você pelo WhatsApp.
          </Text>
        </VStack>
      </Box>
    </Center>
  );
}

export default SuccessScreen;
